import React from 'react';
import PropTypes from 'prop-types';
import AllocationGrid from 'shared/components/allocationGrid/AllocationGrid';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import { RULE_PROP_TYPE } from 'shared/constants/PropTypes';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';

class AllocationGridSlidingPanel extends React.PureComponent {
  componentDidMount() {
    this.props.rulesActions.fetchAllocationRules();
  }

  handleCloseAllocationSlidingPanel = () => this.props.onClose();

  handleApplyButton = () => {
    const { selectedInvoiceId, invoiceLinesPageState } = this.props;
    const { status } = this.state;
    const allocationInformation = {
      ruleId: this.state.selectedAllocation.id,
      lineIds: this.state.selectedInvoices
    };
    this.props.rulesActions.applyAllocationRuleToLines(allocationInformation, selectedInvoiceId, invoiceLinesPageState, status);
    this.setState({
      openAllocationSlidingPanel: false,
      selectedAllocation: { id: 0, name: '' },
      selectedInvoices: []
    });
  };

  handleAllocationPageChange = (page, perPage) =>
    this.props.rulesActions.fetchAllocationRules(page, perPage);

  render () {
    const {
      open,
      selectedAllocation,
      rules,
      fetchingRules,
      allocationPageState
    } = this.props;
    return (
      <SovosEditableSlidingPanel
        isDirty={ () => true }
        open={ open }
        onClose={ this.handleCloseAllocationSlidingPanel }
        baseWidth={ '1230px' }
        title={ `Apply Allocation` }
        dialogTitle={ SLIDING_PANEL_DIALOG_TITLE }
        dialogText={ SLIDING_PANEL_DIALOG_TEXT }
        dialogContentClassName={ SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME }
        dialogActionLabel={ SLIDING_PANEL_DIALOG_ACTION_LABEL }
        SaveButtonProps={ {
          onClick: this.handleApplyButton,
          disabled: selectedAllocation.id === 0,
          children: 'APPLY'
        } }
        CancelButtonProps={ {
          children: 'CANCEL'
        } }
        CloseDialogProps={ {
          DialogTitleProps: {
            children: SLIDING_PANEL_DIALOG_TITLE,
            className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
          },
          DialogContentProps: {
            children: SLIDING_PANEL_DIALOG_TEXT,
            className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
          },
          OKButtonProps: {
            children: SLIDING_PANEL_DIALOG_ACTION_LABEL
          },
          CancelButtonProps: {
            children: 'CANCEL'
          }
        } }
      >
        <AllocationGrid
          onAllocationSelect={ allocation =>
            this.onAllocationSelect(allocation)
          }
          allocationRules={ rules }
          fetchingAllocations={ fetchingRules }
          pageState={ allocationPageState }
          onPageChange={ (page, perPage) =>
            this.handleAllocationPageChange(page, perPage)
          }
        />
      </SovosEditableSlidingPanel>
    );
  }
}

AllocationGridSlidingPanel.propTypes = {
  fetchingRules: PropTypes.bool,
  open: PropTypes.bool,
  rules: PropTypes.arrayOf(RULE_PROP_TYPE),
  rulesActions: PropTypes.shape({
    fetchAllocationRules: PropTypes.func,
    applyAllocationRuleToLines: PropTypes.func
  }),
  onClose: PropTypes.func,
  allocationPageState: PropTypes.object,
  selectedAllocation: PropTypes.object,
  selectedInvoiceId: PropTypes.number.isRequired,
  invoiceLinesPageState: PropTypes.object.isRequired,
};

export default AllocationGridSlidingPanel;


// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesGrid/c/allocationGridSlidingPanel/AllocationGridSlidingPanel.js